import React, { Component } from 'react';
import { API_ENDPOINTS, postRequest } from '../config/apiConfig';

/* ── Load jsQR ─────────────────────────────────────────────── */
function loadJsQR() {
  return new Promise(resolve => {
    if (window.jsQR) { resolve(); return; }
    const s = document.createElement('script');
    s.src = 'https://unpkg.com/jsqr@1.4.0/dist/jsQR.js';
    s.onload = resolve;
    document.head.appendChild(s);
  });
}

export class DoctorQRScanPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status:      'scan',   // scan | loading | success | error
      errorMsg:    '',
      doctorName:  '',
      inlineCamOn: false,
      inlineCamErr: '',
    };
    this.fileRef   = React.createRef();
    this.cameraRef = React.createRef();
    this.videoRef  = React.createRef();
    this.canvasRef = React.createRef();
    this.streamRef = null;
    this.scanLoop  = null;
  }

  componentDidMount() {
    // Check if doctor_id passed in URL: /doctorScan?id=DG-DOC-00001
    const params = new URLSearchParams(window.location.search);
    const urlId  = params.get('id') || params.get('doctor_id');
    if (urlId) {
      this.loginDoctor(urlId);
      return;
    }
    // Auto-start camera
    this.startCamera();
  }

  componentWillUnmount() { this.stopCamera(); }

  async startCamera() {
    await loadJsQR();
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: { ideal: 'environment' }, width:{ ideal:1280 }, height:{ ideal:720 } }
      });
      this.streamRef = stream;
      this.setState({ inlineCamOn: true, inlineCamErr: '' });
      setTimeout(() => {
        if (this.videoRef.current) {
          this.videoRef.current.srcObject = stream;
          this.videoRef.current.play();
          this.videoRef.current.onloadedmetadata = () => this.startScanLoop();
        }
      }, 300);
    } catch(err) {
      this.setState({ inlineCamOn: false, inlineCamErr: 'Camera unavailable — use Upload or enter ID below' });
    }
  }

  stopCamera() {
    if (this.scanLoop)  { cancelAnimationFrame(this.scanLoop); this.scanLoop = null; }
    if (this.streamRef) { this.streamRef.getTracks().forEach(t => t.stop()); this.streamRef = null; }
    this.setState({ inlineCamOn: false });
  }

  startScanLoop() {
    const tick = () => {
      const v = this.videoRef.current, c = this.canvasRef.current;
      if (!v || !c) return;
      c.width = v.videoWidth; c.height = v.videoHeight;
      const ctx = c.getContext('2d');
      ctx.drawImage(v, 0, 0);
      const d = ctx.getImageData(0, 0, c.width, c.height);
      const code = window.jsQR(d.data, d.width, d.height, { inversionAttempts: 'dontInvert' });
      if (code) { this.stopCamera(); this.parseQR(code.data); return; }
      this.scanLoop = requestAnimationFrame(tick);
    };
    this.scanLoop = requestAnimationFrame(tick);
  }

  async decodeFromFile(file) {
    if (!file) return;
    await loadJsQR();
    this.setState({ status: 'loading' });
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const MAX = 1024;
        let w = img.width, h = img.height;
        if (w > MAX || h > MAX) {
          if (w > h) { h = Math.round(h * MAX / w); w = MAX; }
          else       { w = Math.round(w * MAX / h); h = MAX; }
        }
        const c = document.createElement('canvas');
        c.width = w; c.height = h;
        const ctx = c.getContext('2d');
        ctx.drawImage(img, 0, 0, w, h);
        const d = ctx.getImageData(0, 0, w, h);
        let code = window.jsQR(d.data, d.width, d.height, { inversionAttempts: 'dontInvert' });
        if (!code) code = window.jsQR(d.data, d.width, d.height, { inversionAttempts: 'invertFirst' });
        if (code) { this.parseQR(code.data); }
        else { this.setState({ status: 'error', errorMsg: 'Could not read QR code. Try a clearer photo.' }); }
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  parseQR(raw) {
    console.log('Doctor QR raw:', raw);
    let doctorId = null;
    // URL format: /doctorScan?id=DG-DOC-00001
    try { const u = new URL(raw); doctorId = u.searchParams.get('id') || u.searchParams.get('doctor_id'); } catch(_) {}
    // Plain text: DG-DOC-00001
    if (!doctorId) { const m = raw.match(/([A-Z0-9\-]+)/); if (m) doctorId = m[1]; }
    if (!doctorId && raw.trim()) doctorId = raw.trim();

    if (doctorId) { this.loginDoctor(doctorId); }
    else { this.setState({ status: 'error', errorMsg: 'Invalid QR — no Doctor ID found.' }); }
  }

  async loginDoctor(doctorId) {
    this.setState({ status: 'loading' });
    try {
      const res  = await postRequest(API_ENDPOINTS.DOCTOR_LOGIN, { doctor_id: doctorId.trim() });
      const data = await res.json();
      console.log('Doctor QR login:', data);

      if (res.ok || data.status) {
        const raw  =Array.isArray(data) ? data[0] : data;
        const user = raw.data ? raw.data.Doctor[0] : raw;

        const loggedUser = {
          personId:   user?.DoctorID,
          name:       `Dr. ${user?.FirstName||''} ${user?.LastName||''}`.trim(),
          email:      user?.Email      || '',
          role:       'doctor',
          doctorId:   doctorId.trim(),
          doctorCode: doctorId.trim(),
        };

        localStorage.setItem('dg_user', JSON.stringify(loggedUser));
        this.setState({ status: 'success', doctorName: loggedUser.name });

       
        setTimeout(() => {
           window.location.href = '/scan';
        }, 1200);

      } else {
        this.setState({ status: 'error', errorMsg: data.message || 'Invalid Doctor QR Code.' });
      }
    } catch(err) {
      this.setState({ status: 'error', errorMsg: 'Cannot connect to server.' });
    }
  }

  reset() {
    this.setState({ status: 'scan', errorMsg: '', inlineCamErr: '' });
    this.startCamera();
  }

  render() {
    const { status, errorMsg, doctorName, inlineCamOn, inlineCamErr } = this.state;

    const card = {
      background: '#fff', borderRadius: 20, padding: '32px 28px',
      width: '100%', maxWidth: 400,
      boxShadow: '0 8px 40px rgba(0,0,0,.10)', border: '1px solid #e5e7eb',
    };

    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: '#f0f4ff', fontFamily: "'Plus Jakarta Sans','Outfit',sans-serif", padding: 16,
      }}>
        <div style={card}>

          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <div style={{
              width: 56, height: 56, borderRadius: 16,
              background: '#EFF6FF', display: 'flex',
              alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px',
            }}>
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#1a6ef5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
                <rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="3" height="3"/>
                <rect x="20" y="14" width="1" height="3"/><rect x="14" y="20" width="3" height="1"/>
                <rect x="20" y="20" width="1" height="1"/>
              </svg>
            </div>
            <h1 style={{ fontSize: 20, fontWeight: 800, color: '#0a0f1e', margin: 0 }}>Doctor QR</h1>
            <p style={{ color: '#6b748c', fontSize: 13, margin: '6px 0 0' }}>Scan your Doctor QR code to access dashboard</p>
          </div>

          {/* SCAN state */}
          {status === 'scan' && (
            <>
              {/* Camera preview */}
              <div style={{
                position: 'relative', borderRadius: 16, overflow: 'hidden',
                background: '#000', marginBottom: 16, width: '100%', aspectRatio: '1',
              }}>
                <video ref={this.videoRef} muted playsInline autoPlay
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: inlineCamOn ? 'block' : 'none' }} />
                <canvas ref={this.canvasRef} style={{ display: 'none' }} />

                {/* Corner overlay */}
                {inlineCamOn && (
                  <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}>
                    <div style={{ width: 160, height: 160, position: 'relative' }}>
                      {[['top','left'],['top','right'],['bottom','left'],['bottom','right']].map(([v,h],i) => (
                        <div key={i} style={{
                          position: 'absolute', [v]: 0, [h]: 0, width: 28, height: 28,
                          borderTop: v==='top' ? '3px solid #fff' : 'none',
                          borderBottom: v==='bottom' ? '3px solid #fff' : 'none',
                          borderLeft: h==='left' ? '3px solid #fff' : 'none',
                          borderRight: h==='right' ? '3px solid #fff' : 'none',
                          borderRadius: 3,
                        }} />
                      ))}
                      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', color: 'rgba(255,255,255,.7)', fontSize: 11, textAlign: 'center', whiteSpace: 'nowrap' }}>
                        Point at Doctor QR
                      </div>
                    </div>
                  </div>
                )}

                {/* No camera */}
                {!inlineCamOn && (
                  <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.4)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/>
                    </svg>
                    <div style={{ fontSize: 12, color: 'rgba(255,255,255,.6)', textAlign: 'center', padding: '0 16px' }}>
                      {inlineCamErr || 'Starting camera…'}
                    </div>
                    {inlineCamErr && (
                      <button onClick={() => this.startCamera()}
                        style={{ padding: '6px 14px', borderRadius: 20, border: '1.5px solid rgba(255,255,255,.4)', background: 'transparent', color: '#fff', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit' }}>
                        Try Again
                      </button>
                    )}
                  </div>
                )}
              </div>

              {/* Hidden inputs */}
              <input ref={this.fileRef} type="file" accept="image/*" style={{ display: 'none' }}
                onChange={e => { if (e.target.files[0]) this.decodeFromFile(e.target.files[0]); }} />
              <input ref={this.cameraRef} type="file" accept="image/*" capture="environment" style={{ display: 'none' }}
                onChange={e => { if (e.target.files[0]) this.decodeFromFile(e.target.files[0]); }} />

              {/* Buttons */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
                <button onClick={() => { this.fileRef.current.value = ''; this.fileRef.current.click(); }}
                  style={{ height: 46, borderRadius: 12, border: 'none', background: '#1a6ef5', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"/></svg>
                  Upload QR
                </button>
                <button onClick={() => { this.cameraRef.current.value = ''; this.cameraRef.current.click(); }}
                  style={{ height: 46, borderRadius: 12, border: 'none', background: '#059669', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></svg>
                  Take Photo
                </button>
              </div>

              {/* Back to login */}
              {this.props.onBack && (
                <button onClick={this.props.onBack}
                  style={{ width: '100%', height: 42, borderRadius: 12, border: '1.5px solid #e5e7eb', background: 'transparent', color: '#6b748c', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
                  ← Back to Login
                </button>
              )}
            </>
          )}

          {/* LOADING state */}
          {status === 'loading' && (
            <div style={{ textAlign: 'center', padding: '24px 0' }}>
              <div style={{ width: 48, height: 48, border: '4px solid #e5e7eb', borderTop: '4px solid #1a6ef5', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto 16px' }} />
              <div style={{ fontWeight: 700, color: '#0a0f1e', fontSize: 15 }}>Verifying Doctor ID…</div>
              <div style={{ color: '#6b748c', fontSize: 13, marginTop: 6 }}>Please wait</div>
            </div>
          )}

          {/* SUCCESS state */}
          {status === 'success' && (
            <div style={{ textAlign: 'center', padding: '24px 0' }}>
              <div style={{ width: 56, height: 56, borderRadius: '50%', background: '#F0FDF4', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5"/></svg>
              </div>
              <div style={{ fontWeight: 800, fontSize: 18, color: '#059669', marginBottom: 6 }}>Welcome again Doctor!</div>
              <div style={{ color: '#6b748c', fontSize: 14 }}>{doctorName}</div>
              <div style={{ color: '#9ca3af', fontSize: 12, marginTop: 8 }}>Redirecting to dashboard…</div>
            </div>
          )}

          {/* ERROR state */}
          {status === 'error' && (
            <div style={{ textAlign: 'center', padding: '24px 0' }}>
              <div style={{ width: 56, height: 56, borderRadius: '50%', background: '#FFF0EB', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FF6B35" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              </div>
              <div style={{ fontWeight: 800, fontSize: 16, color: '#FF6B35', marginBottom: 8 }}>Login Failed</div>
              <div style={{ color: '#6b748c', fontSize: 13, marginBottom: 20 }}>{errorMsg}</div>
              <button onClick={() => this.reset()}
                style={{ padding: '10px 28px', borderRadius: 12, border: 'none', background: '#1a6ef5', color: '#fff', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
                Try Again
              </button>
            </div>
          )}
        </div>

        <style>{`@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}`}</style>
      </div>
    );
  }
}

export default DoctorQRScanPage;